/** Emoji/sticker shown next to the keywords-found count in the results toolbar. */
export function getKeywordsFoundEmoji(count: number): string {
  if (count <= 0) return '🌱';
  if (count < 50) return '🙂‍↕️';
  if (count < 100) return '🙂‍↔️';
  if (count < 150) return '🙂';
  if (count < 200) return '😋';
  if (count < 250) return '😊';
  if (count < 300) return '🔥';
  if (count < 350) return '💪';
  if (count < 400) return '🚀';
  if (count < 450) return '✨';
  return '😍';
}
